"use strict";
// These are copied from the service as are not expected to change frequently
// in order to avoid pulling in the service dependency into consumers
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const consts_1 = require("../consts");
function constructTransformersString(transformers) {
    return Object.keys(transformers)
        .reduce((acc, key) => {
        const shortParamName = consts_1.ReverseTransformersMap[key];
        if (!shortParamName) {
            throw new client_library_1.InvalidParamError(key);
        }
        const encodedTransformerValue = encodeURIComponent(transformers[key]);
        return [...acc, `${shortParamName}_${encodedTransformerValue}`];
    }, [])
        .sort()
        .join(',');
}
exports.default = constructTransformersString;
